var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var Webhook = /** @class */ (function (_super) {
    __extends(Webhook, _super);
    function Webhook() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new webhook
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/webhook/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Webhook.prototype.create = function (body) {
        return this.rawCreate(Utils.serializeRequestBody(body, {
            type: 'webhook',
            attributes: [
                'name',
                'url',
                'custom_payload',
                'headers',
                'events',
                'http_basic_user',
                'http_basic_password',
                'enabled',
                'payload_api_version',
                'nested_items_in_payload',
                'auto_retry',
            ],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Create a new webhook
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/webhook/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Webhook.prototype.rawCreate = function (body) {
        return this.client.request({
            method: 'POST',
            url: '/webhooks',
            body: body,
        });
    };
    /**
     * Update a webhook
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/webhook/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Webhook.prototype.update = function (webhookId, body) {
        return this.rawUpdate(Utils.toId(webhookId), Utils.serializeRequestBody(body, {
            id: Utils.toId(webhookId),
            type: 'webhook',
            attributes: [
                'name',
                'url',
                'custom_payload',
                'headers',
                'events',
                'http_basic_user',
                'http_basic_password',
                'enabled',
                'payload_api_version',
                'nested_items_in_payload',
                'auto_retry',
            ],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Update a webhook
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/webhook/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Webhook.prototype.rawUpdate = function (webhookId, body) {
        return this.client.request({
            method: 'PUT',
            url: "/webhooks/".concat(webhookId),
            body: body,
        });
    };
    /**
     * List all webhooks
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/webhook/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Webhook.prototype.list = function () {
        return this.rawList().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * List all webhooks
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/webhook/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Webhook.prototype.rawList = function () {
        return this.client.request({
            method: 'GET',
            url: '/webhooks',
        });
    };
    /**
     * Retrieve a webhook
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/webhook/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Webhook.prototype.find = function (webhookId) {
        return this.rawFind(Utils.toId(webhookId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve a webhook
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/webhook/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Webhook.prototype.rawFind = function (webhookId) {
        return this.client.request({
            method: 'GET',
            url: "/webhooks/".concat(webhookId),
        });
    };
    /**
     * Delete a webhook
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/webhook/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Webhook.prototype.destroy = function (webhookId) {
        return this.rawDestroy(Utils.toId(webhookId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Delete a webhook
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/webhook/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Webhook.prototype.rawDestroy = function (webhookId) {
        return this.client.request({
            method: 'DELETE',
            url: "/webhooks/".concat(webhookId),
        });
    };
    Webhook.TYPE = 'webhook';
    return Webhook;
}(BaseResource));
export default Webhook;
//# sourceMappingURL=Webhook.js.map